import React from 'react'
import { Button } from 'semantic-ui-react'

export default function ConfirmDeletionModal({
  modal: Modal,
  close,
  handleDelete,
  loading,
  title,
  description,
}) {
  return (
    <Modal size="tiny">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <p>{description}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={handleDelete} disabled={loading} loading={loading} negative>
          {title}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/ConfirmDeletionModal.js